import React, { useEffect, useState } from 'react';
import './AnalisisPagos.css';

const AnalisisPagos = ({ contextoUsuario, isOpen, onClose }) => {
  const [analisisData, setAnalisisData] = useState(null);
  const [datosLaborales, setDatosLaborales] = useState(null);
  const [loading, setLoading] = useState(true);

  // Prevenir scroll del body cuando el modal está abierto
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  useEffect(() => {
    // Extraer los datos laborales importantes del perfil y datos personales
    const extraerDatosLaborales = () => {
      console.log("Extrayendo datos laborales y personales del contexto:", contextoUsuario);
      
      // Buscar datos personales básicos primero (nombre y documento)
      const datosPersonales = {
        empleado: null,
        documento: null
      };
      
      // Intentar obtener nombre y documento de varias fuentes
      const fuentesPersonales = [
        contextoUsuario?.datos?.datosOriginales?.datos_contextousuarios,
        contextoUsuario?.datosOriginales?.datos_contextousuarios,
        contextoUsuario?.datos?.perfil,
        contextoUsuario?.datosOriginales?.perfil
      ];
      
      for (const fuente of fuentesPersonales) {
        if (fuente) {
          if (fuente.empleado && !datosPersonales.empleado) {
            datosPersonales.empleado = fuente.empleado;
          }
          if (!datosPersonales.documento && (fuente.documento || fuente.CEDULA || fuente.cedula)) {
            datosPersonales.documento = fuente.documento || fuente.CEDULA || fuente.cedula;
          }
        }
      }
      
      // Buscar datos InfoParris1
      const datosInfoParris = {
        fe_nacido: null,
        fe_ingreso: null,
        fe_causa: null,
        fe_adquiere: null,
        ciudad_iss: null,
        dir_iss: null,
        mesada: null,
        semanas: null,
        res_nro: null,
        res_ano: null,
        riesgo: null
      };
      
      // Buscar en diferentes ubicaciones posibles
      const fuentesInfoParris = [
        contextoUsuario?.datos?.datosOriginales?.datos_contextousuarios?.infoParris1,
        contextoUsuario?.datosOriginales?.datos_contextousuarios?.infoParris1,
        contextoUsuario?.datos?.infoParris1,
        contextoUsuario?.datosOriginales?.infoParris1
      ];
      
      for (const fuente of fuentesInfoParris) {
        if (fuente) {
          Object.keys(datosInfoParris).forEach(key => {
            if (fuente[key] !== undefined && datosInfoParris[key] === null) {
              datosInfoParris[key] = fuente[key];
            }
          });
        }
      }
      
      // Buscar datos en varias posibles ubicaciones para datos laborales
      const perfilPosibles = [
        contextoUsuario?.datos?.perfil,
        contextoUsuario?.datosOriginales?.perfil,
        contextoUsuario?.datos?.datosOriginales?.datos_contextousuarios?.perfil,
        contextoUsuario?.datosOriginales?.datos_contextousuarios
      ];
      
      // Lista de todos los campos laborales que queremos extraer
      const camposLaborales = {
        INGRESO_DISCONTINUO: ["INGRESO_DISCONTINUO", "INGRESO DISCONTINUO"],
        RETIRO_DISCONTINUO: ["RETIRO_DISCONTINUO", "RETIRO DISCONTINUO"],
        INGRESO: ["INGRESO"],
        EGRESO: ["EGRESO"],
        TIEMPO_LABORADO: ["TIEMPO_LABORADO", "TIEMPO LABORADO"],
        SUELDO_PROMEDIO: ["SUELDO_PROMEDIO", "SUELDO PROMEDIO"],
        JUBILACION_ELECTRICARIBE: ["JUBILACION_ELECTRICARIBE", "JUBILACION ELECTRICARIBE"],
        PENSION_JUBILACION_1999: ["PENSION_JUBILACION_1999", "PENSION DE JUBILACION 1999"],
        COMPARTICION: ["COMPARTICION", "COMPARTICON"],
        PENSION_JUBILACION_2006: ["PENSION_JUBILACION_2006", "PENSION DE JUBILACION AÑO 2006"],
        PENSION_VEJEZ_2006: ["PENSION_VEJEZ_2006", "PENSION DE VEJEZ AÑO 2006"],
        MAYOR_VALOR_CARGO_EMPRESA: ["MAYOR_VALOR_CARGO_EMPRESA", "MAYOR VALOR A CARGO EMPRESA"],
        EDAD_TERMINACION_CONTRATO: ["EDAD_TERMINACION_CONTRATO", "EDAD A LA FECHA DE TERMINACION CONTRATO"],
        CARGO: ["CARGO"],
        DOMICILIO: ["DOMICILIO"],
        DIRECCION: ["DIRECCION"],
        CELULAR: ["CELULAR"],
        CORREO_ELECTRONICO: ["CORREO_ELECTRONICO", "CORREO ELECTRONICO"],
        ESTADO_CIVIL: ["ESTADO_CIVIL", "ESTADO CIVIL"],
        NOMBRE_CONYUGUE: ["NOMBRE_CONYUGUE", "NOMBRE DEL CONYUGUE"],
        CELULAR_CONYUGUE: ["CELULAR_CONYUGUE", "CELULAR CONYUGUE"],
        NIT_FIDUPREVISORA: ["NIT_FIDUPREVISORA", "NIT FIDUPREVISORA"],
        NIT_COLPENSIONES: ["NIT_COLPENSIONES", "NIT COLPENSIONES"]
      };
      
      // Objeto para almacenar los valores encontrados
      const datosExtraidos = {};
      
      // Buscar en todos los lugares posibles
      for (const perfil of perfilPosibles) {
        if (perfil) {
          // Extraer datos laborales si existen
          Object.entries(camposLaborales).forEach(([nombreCampo, variantes]) => {
            if (datosExtraidos[nombreCampo] === undefined) {
              for (const variante of variantes) {
                if (perfil[variante] !== undefined) {
                  datosExtraidos[nombreCampo] = perfil[variante];
                  break;
                }
              }
            }
          });
        }
      }
      
      // Combinar todos los datos
      return {
        ...datosPersonales,
        ...datosInfoParris,
        ...datosExtraidos
      };
    };
    
    // Función para buscar la estructura de datos de pagos en el objeto anidado
    const encontrarDatosPagos = () => {
      console.log("Buscando datos de pagos en contexto:", contextoUsuario);
      
      // Intentar encontrar los datos de pagos en varias posibles rutas
      const rutas = [
        // Ruta 1: Directamente en datos.pagosPensionado
        contextoUsuario?.datos?.pagosPensionado,
        
        // Ruta 2: En infoPensionado.pagosPensionado de datos
        contextoUsuario?.datos?.infoPensionado?.pagosPensionado,
        
        // Ruta 3: En datos_contextousuarios.infoPensionado.pagosPensionado
        contextoUsuario?.datos?.datosOriginales?.datos_contextousuarios?.infoPensionado?.pagosPensionado,
        
        // Ruta 4: En datosOriginales.datos_contextousuarios.infoPensionado.pagosPensionado
        contextoUsuario?.datosOriginales?.datos_contextousuarios?.infoPensionado?.pagosPensionado,
        
        // Ruta 5: En datosOriginales.infoPensionado.pagosPensionado
        contextoUsuario?.datosOriginales?.infoPensionado?.pagosPensionado,
        
        // Ruta 6: En perfil.pagosPensionado
        contextoUsuario?.datos?.perfil?.pagosPensionado
      ];
      
      // Devolver la primera ruta que contenga datos
      for (const ruta of rutas) {
        if (ruta && Array.isArray(ruta) && ruta.length > 0) {
          console.log("Datos de pagos encontrados:", ruta);
          return ruta;
        }
      }
      
      console.log("No se encontraron datos de pagos en ninguna ruta conocida");
      return null;
    };

    if (contextoUsuario) {
      console.log("Iniciando análisis de pagos para usuario:", contextoUsuario.iddoc);
      
      // Obtener datos laborales
      const laborales = extraerDatosLaborales();
      setDatosLaborales(laborales);
      
      // Intentar obtener los datos de pagos
      const pagos = encontrarDatosPagos();
      
      if (pagos && pagos.length > 0) {
        console.log(`Encontrados ${pagos.length} registros de pagos. Procesando...`);
        // Procesar los pagos y generar análisis
        const analisis = procesarPagos(pagos);
        
        // Guardar en localStorage
        if (analisis && contextoUsuario.iddoc) {
          localStorage.setItem(`analisis_pagos_${contextoUsuario.iddoc}`, JSON.stringify(analisis));
        }
        
        setAnalisisData(analisis);
        setLoading(false);
      } else {
        // Intentar recuperar del localStorage si existe
        if (contextoUsuario.iddoc) {
          console.log("Intentando recuperar análisis desde localStorage...");
          const cachedData = localStorage.getItem(`analisis_pagos_${contextoUsuario.iddoc}`);
          if (cachedData) {
            console.log("Datos recuperados de localStorage");
            setAnalisisData(JSON.parse(cachedData));
            setLoading(false);
            return;
          }
        }
        
        console.log("No se encontraron datos de pagos para analizar");
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  }, [contextoUsuario]);

  // Función para procesar los pagos y generar análisis
  const procesarPagos = (pagos) => {
    if (!Array.isArray(pagos) || pagos.length === 0) return null;

    // Agrupar pagos por año
    const pagosPorAnio = {};
    
    // Arrays para conceptos especiales
    const mesadasAdicionales = [];
    const costasYSentencias = [];
    const retroactivos = [];
    
    pagos.forEach(pago => {
      // Extraer el año del pago
      const anio = pago.año || extraerAnioDeFecha(pago.periodoPago);
      
      if (!anio) return; // Saltamos pagos sin año definido
      
      if (!pagosPorAnio[anio]) {
        pagosPorAnio[anio] = [];
      }
      
      // Extraer la mesada pensional y otros conceptos especiales
      let mesadaPensional = null;
      let mesadaAdicional = null;
      let costasProc = null;
      let retroM14 = null;
      let sentencias = null;
      
      if (pago.detalles && Array.isArray(pago.detalles)) {
        // Buscar mesada pensional regular
        const detalleMesada = pago.detalles.find(d => 
          d.nombre?.includes("Mesada Pensional") || d.codigo === "MESAD");
          
        if (detalleMesada) {
          mesadaPensional = detalleMesada.ingresos;
        }
        
        // Buscar mesada adicional (prima de junio o diciembre)
        const detalleMesadaAdicional = pago.detalles.find(d => 
          d.nombre?.includes("Mesada Adicional") || 
          d.codigo === "PRIMA" || 
          d.nombre?.includes("Prima") ||
          d.nombre?.includes("prima de") ||
          d.codigo === "M13" || 
          d.codigo === "M14");
          
        if (detalleMesadaAdicional) {
          mesadaAdicional = detalleMesadaAdicional.ingresos;
          
          // Determinar mes para categorizar (junio o diciembre)
          let mesPago = "No especificado";
          if (pago.periodoPago) {
            if (pago.periodoPago.toLowerCase().includes("jun")) {
              mesPago = "junio";
            } else if (pago.periodoPago.toLowerCase().includes("dic")) {
              mesPago = "diciembre";
            }
          }
          
          mesadasAdicionales.push({
            anio,
            periodo: pago.periodoPago || `Adicional ${anio}`,
            valor: mesadaAdicional,
            fecha: pago.fechaLiquidacion,
            mes: mesPago
          });
        }
        
        // Buscar costas procesales
        const detalleCostas = pago.detalles.find(d => 
          d.codigo === "470" || d.nombre?.includes("Costas Procesales"));
          
        if (detalleCostas) {
          costasProc = detalleCostas.ingresos;
          costasYSentencias.push({
            anio,
            periodo: pago.periodoPago || `${anio}`,
            concepto: "Costas Procesales",
            valor: costasProc,
            fecha: pago.fechaLiquidacion
          });
        }
        
        // Buscar retroactivos M14
        const detalleRetroM14 = pago.detalles.find(d => 
          d.codigo === "785" || d.nombre?.includes("Retro Mesada Adicional M14"));
          
        if (detalleRetroM14) {
          retroM14 = detalleRetroM14.ingresos;
          retroactivos.push({
            anio,
            periodo: pago.periodoPago || `${anio}`,
            concepto: "Retroactivo Mesada M14",
            valor: retroM14,
            fecha: pago.fechaLiquidacion
          });
        }
        
        // Buscar procesos judiciales
        const detalleSentencias = pago.detalles.find(d => 
          d.codigo === "475" || d.nombre?.includes("Procesos Y Sentencia"));
          
        if (detalleSentencias) {
          sentencias = detalleSentencias.ingresos;
          costasYSentencias.push({
            anio,
            periodo: pago.periodoPago || `${anio}`,
            concepto: "Procesos y Sentencias Judiciales",
            valor: sentencias,
            fecha: pago.fechaLiquidacion
          });
        }
      }
      
      if (mesadaPensional !== null) {
        pagosPorAnio[anio].push({
          periodo: pago.periodoPago,
          mesada: mesadaPensional,
          valorNeto: limpiarValorMonetario(pago.valorNeto),
          fecha: pago.fechaLiquidacion,
          mesadaAdicional: mesadaAdicional,
          tieneAdicional: mesadaAdicional !== null,
          conceptosEspeciales: {
            costas: costasProc,
            retroM14: retroM14,
            sentencias: sentencias
          }
        });
      }
    });
    
    // Calcular estadísticas por año
    const estadisticasPorAnio = {};
    let todasLasMesadas = [];
    
    for (const [anio, pagosList] of Object.entries(pagosPorAnio)) {
      // Ordenar pagos por periodo
      pagosList.sort((a, b) => {
        return parseDate(a.periodo) - parseDate(b.periodo);
      });
      
      // Extraer solo los valores de las mesadas
      const mesadas = pagosList.map(p => p.mesada);
      todasLasMesadas = [...todasLasMesadas, ...mesadas];
      
      // Extraer mesadas adicionales del año
      const mesadasAdicionalesAnio = mesadasAdicionales.filter(m => m.anio === anio);
      const totalAdicionales = mesadasAdicionalesAnio.reduce((sum, m) => sum + m.valor, 0);
      
      // Extraer costas y sentencias del año
      const costasYSentenciasAnio = costasYSentencias.filter(c => c.anio === anio);
      const totalCostasYSentencias = costasYSentenciasAnio.reduce((sum, c) => sum + c.valor, 0);
      
      // Extraer retroactivos del año
      const retroactivosAnio = retroactivos.filter(r => r.anio === anio);
      const totalRetroactivos = retroactivosAnio.reduce((sum, r) => sum + r.valor, 0);
      
      // Calcular variaciones entre pagos consecutivos
      const variaciones = [];
      for (let i = 1; i < pagosList.length; i++) {
        const diferencia = pagosList[i].mesada - pagosList[i-1].mesada;
        const porcentaje = (diferencia / pagosList[i-1].mesada) * 100;
        
        variaciones.push({
          desde: pagosList[i-1].periodo,
          hasta: pagosList[i].periodo,
          diferencia,
          porcentaje: parseFloat(porcentaje.toFixed(2))
        });
      }
      
      estadisticasPorAnio[anio] = {
        pagos: pagosList,
        cantidadPagos: pagosList.length,
        media: calcularMedia(mesadas),
        mediana: calcularMediana(mesadas),
        maximo: Math.max(...mesadas),
        minimo: Math.min(...mesadas),
        variaciones: variaciones,
        incrementoTotal: variaciones.length > 0 
          ? (pagosList[pagosList.length-1].mesada - pagosList[0].mesada) 
          : 0,
        porcentajeIncrementoTotal: variaciones.length > 0 
          ? parseFloat(((pagosList[pagosList.length-1].mesada - pagosList[0].mesada) / pagosList[0].mesada * 100).toFixed(2))
          : 0,
        // Nuevos campos para mesadas adicionales y conceptos especiales
        mesadasAdicionales: mesadasAdicionalesAnio,
        cantidadMesadasAdicionales: mesadasAdicionalesAnio.length,
        totalMesadasAdicionales: totalAdicionales,
        costasYSentencias: costasYSentenciasAnio,
        totalCostasYSentencias: totalCostasYSentencias,
        retroactivos: retroactivosAnio,
        totalRetroactivos: totalRetroactivos
      };
    }
    
    // Estadísticas globales
    const estadisticasGlobales = {
      totalPagos: todasLasMesadas.length,
      mediaTodos: calcularMedia(todasLasMesadas),
      medianaTodos: calcularMediana(todasLasMesadas),
      maximoHistorico: Math.max(...todasLasMesadas),
      minimoHistorico: Math.min(...todasLasMesadas),
      anios: Object.keys(estadisticasPorAnio).sort(),
      // Nuevos campos para mesadas adicionales y conceptos especiales
      mesadasAdicionales: mesadasAdicionales,
      cantidadMesadasAdicionales: mesadasAdicionales.length,
      totalMesadasAdicionales: mesadasAdicionales.reduce((sum, m) => sum + m.valor, 0),
      costasYSentencias: costasYSentencias,
      totalCostasYSentencias: costasYSentencias.reduce((sum, c) => sum + c.valor, 0),
      retroactivos: retroactivos,
      totalRetroactivos: retroactivos.reduce((sum, r) => sum + r.valor, 0)
    };
    
    return {
      porAnio: estadisticasPorAnio,
      global: estadisticasGlobales,
      conceptosEspeciales: {
        mesadasAdicionales,
        costasYSentencias,
        retroactivos
      }
    };
  };
  
  // Función para calcular la media
  const calcularMedia = (arr) => {
    if (!arr.length) return 0;
    const suma = arr.reduce((a, b) => a + b, 0);
    return parseFloat((suma / arr.length).toFixed(2));
  };
  
  // Función para calcular la mediana
  const calcularMediana = (arr) => {
    if (!arr.length) return 0;
    const sorted = [...arr].sort((a, b) => a - b);
    const mid = Math.floor(sorted.length / 2);
    return sorted.length % 2 === 0
      ? parseFloat(((sorted[mid - 1] + sorted[mid]) / 2).toFixed(2))
      : sorted[mid];
  };
  
  // Función para limpiar valores monetarios (quitar puntos, comas y convertir a número)
  const limpiarValorMonetario = (valor) => {
    if (!valor) return 0;
    if (typeof valor === 'number') return valor;
    
    const limpio = valor.replace(/\./g, '').replace(/,/g, '.').replace(/\s/g, '');
    return parseFloat(limpio) || 0;
  };
  
  // Función para extraer año de una fecha en formato texto
  const extraerAnioDeFecha = (texto) => {
    if (!texto) return null;
    
    // Intenta extraer una fecha con formato "1 mar. 2023 a 31 mar. 2023"
    const match = texto.match(/\b(19|20)\d{2}\b/);
    return match ? match[0] : null;
  };
  
  // Función para convertir texto de fecha a objeto Date para ordenamiento
  const parseDate = (texto) => {
    if (!texto) return new Date(0);
    
    const meses = {
      'ene': 0, 'feb': 1, 'mar': 2, 'abr': 3, 'may': 4, 'jun': 5,
      'jul': 6, 'ago': 7, 'sep': 8, 'oct': 9, 'nov': 10, 'dic': 11
    };
    
    try {
      // Para formatos como "1 mar. 2023 a 31 mar. 2023", tomamos la primera fecha
      const match = texto.match(/(\d+)\s+([a-z]{3})\.?\s+(20\d{2})/i);
      
      if (match) {
        const dia = parseInt(match[1]);
        const mes = meses[match[2].toLowerCase()] || 0;
        const anio = parseInt(match[3]);
        
        return new Date(anio, mes, dia);
      }
      
      return new Date(texto);
    } catch (e) {
      return new Date(0);
    }
  };
  
  // Función para formatear moneda
  const formatoMoneda = (valor) => {
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0
    }).format(valor);
  };

  // Formatear fechas para mejor visualización
  const formatearFecha = (fecha) => {
    if (!fecha) return "No disponible";
    return fecha;
  };

  // Formatear valor monetario
  const formatearValor = (valor) => {
    if (!valor) return "No disponible";
    return typeof valor === 'number' ? formatoMoneda(valor) : valor;
  };

  // Función para formatear fechas timestamp
  const formatearTimestamp = (timestamp) => {
    if (!timestamp) return "No disponible";
    try {
      // Si es un timestamp (objeto o número)
      let fecha;
      if (typeof timestamp === 'object' && timestamp.seconds) {
        fecha = new Date(timestamp.seconds * 1000);
      } else if (!isNaN(timestamp)) {
        fecha = new Date(timestamp);
      } else {
        return timestamp.toString();
      }
      
      return fecha.toLocaleDateString('es-CO', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      });
    } catch (error) {
      console.error("Error al formatear fecha:", error);
      return timestamp.toString();
    }
  };

  // Si el modal no está abierto, no renderizamos nada
  if (!isOpen) return null;

  // Contenido del modal
  let contenidoModal;

  if (loading) {
    contenidoModal = <div className="analisis-loading">Analizando pagos de pensión...</div>;
  } else if (!analisisData && datosLaborales) {
    contenidoModal = (
      <div className="analisis-pagos-container">
        <h2>Información Laboral del Pensionado</h2>
        <div className="datos-laborales">
          <div className="datos-laborales-grid">
            <div className="dato-laboral-item">
              <span className="dato-laboral-label">Ingreso:</span>
              <span className="dato-laboral-value">{formatearFecha(datosLaborales.INGRESO)}</span>
            </div>
            <div className="dato-laboral-item">
              <span className="dato-laboral-label">Egreso:</span>
              <span className="dato-laboral-value">{formatearFecha(datosLaborales.EGRESO)}</span>
            </div>
            <div className="dato-laboral-item">
              <span className="dato-laboral-label">Ingreso Discontinuo:</span>
              <span className="dato-laboral-value">{formatearFecha(datosLaborales.INGRESO_DISCONTINUO)}</span>
            </div>
            <div className="dato-laboral-item">
              <span className="dato-laboral-label">Retiro Discontinuo:</span>
              <span className="dato-laboral-value">{formatearFecha(datosLaborales.RETIRO_DISCONTINUO)}</span>
            </div>
            <div className="dato-laboral-item">
              <span className="dato-laboral-label">Tiempo Laborado:</span>
              <span className="dato-laboral-value">{datosLaborales.TIEMPO_LABORADO || "No disponible"}</span>
            </div>
            <div className="dato-laboral-item">
              <span className="dato-laboral-label">Sueldo Promedio:</span>
              <span className="dato-laboral-value">{formatearValor(datosLaborales.SUELDO_PROMEDIO)}</span>
            </div>
          </div>
          <p className="sin-datos-pagos-msg">No se encontraron registros de pagos para analizar</p>
        </div>
      </div>
    );
  } else if (!analisisData) {
    contenidoModal = (
      <div className="sin-datos-analisis">
        <p>No se pudieron encontrar datos de pagos para análisis.</p>
        <p className="debug-info">
          ID Documento: {contextoUsuario?.iddoc || "No disponible"}
        </p>
      </div>
    );
  } else {
    contenidoModal = (
      <div className="analisis-pagos-container">
        <h2>Análisis de Pagos Pensionales</h2>
        
        {/* Información del pensionado */}
        {datosLaborales && (
          <div className="datos-pensionado-section">
            <h3>Información del Pensionado</h3>
            <div className="datos-personales-grid">
              {datosLaborales.empleado && (
                <div className="dato-personal-item">
                  <span className="dato-personal-label">Nombre:</span>
                  <span className="dato-personal-value">{datosLaborales.empleado}</span>
                </div>
              )}
              {datosLaborales.documento && (
                <div className="dato-personal-item">
                  <span className="dato-personal-label">Documento:</span>
                  <span className="dato-personal-value">{datosLaborales.documento}</span>
                </div>
              )}
              {datosLaborales.fe_nacido && (
                <div className="dato-personal-item">
                  <span className="dato-personal-label">Fecha de nacimiento:</span>
                  <span className="dato-personal-value">{formatearTimestamp(datosLaborales.fe_nacido)}</span>
                </div>
              )}
              {datosLaborales.ciudad_iss && (
                <div className="dato-personal-item">
                  <span className="dato-personal-label">Ciudad:</span>
                  <span className="dato-personal-value">{datosLaborales.ciudad_iss}</span>
                </div>
              )}
              {datosLaborales.dir_iss && (
                <div className="dato-personal-item">
                  <span className="dato-personal-label">Dirección ISS:</span>
                  <span className="dato-personal-value">{datosLaborales.dir_iss}</span>
                </div>
              )}
              {datosLaborales.DIRECCION && (
                <div className="dato-personal-item">
                  <span className="dato-personal-label">Dirección:</span>
                  <span className="dato-personal-value">{datosLaborales.DIRECCION}</span>
                </div>
              )}
              {datosLaborales.CELULAR && (
                <div className="dato-personal-item">
                  <span className="dato-personal-label">Celular:</span>
                  <span className="dato-personal-value">{datosLaborales.CELULAR}</span>
                </div>
              )}
              {datosLaborales.CORREO_ELECTRONICO && (
                <div className="dato-personal-item">
                  <span className="dato-personal-label">Correo electrónico:</span>
                  <span className="dato-personal-value">{datosLaborales.CORREO_ELECTRONICO}</span>
                </div>
              )}
              {datosLaborales.ESTADO_CIVIL && (
                <div className="dato-personal-item">
                  <span className="dato-personal-label">Estado civil:</span>
                  <span className="dato-personal-value">{datosLaborales.ESTADO_CIVIL}</span>
                </div>
              )}
              {datosLaborales.NOMBRE_CONYUGUE && (
                <div className="dato-personal-item">
                  <span className="dato-personal-label">Cónyuge:</span>
                  <span className="dato-personal-value">{datosLaborales.NOMBRE_CONYUGUE}</span>
                </div>
              )}
            </div>
          </div>
        )}
        
        {/* Información Laboral */}
        {datosLaborales && (
          <div className="datos-section">
            <h3 className="section-header">Información Laboral</h3>
            <div className="datos-stats-grid">
              {datosLaborales.CARGO && (
                <div className="datos-stat-item">
                  <span className="datos-label">Cargo:</span>
                  <span className="datos-value">{datosLaborales.CARGO}</span>
                </div>
              )}
              {datosLaborales.INGRESO && (
                <div className="datos-stat-item">
                  <span className="datos-label">Ingreso:</span>
                  <span className="datos-value">{formatearFecha(datosLaborales.INGRESO)}</span>
                </div>
              )}
              {datosLaborales.EGRESO && (
                <div className="datos-stat-item">
                  <span className="datos-label">Egreso:</span>
                  <span className="datos-value">{formatearFecha(datosLaborales.EGRESO)}</span>
                </div>
              )}
              {datosLaborales.INGRESO_DISCONTINUO && (
                <div className="datos-stat-item">
                  <span className="datos-label">Ingreso Discontinuo:</span>
                  <span className="datos-value">{formatearFecha(datosLaborales.INGRESO_DISCONTINUO)}</span>
                </div>
              )}
              {datosLaborales.RETIRO_DISCONTINUO && (
                <div className="datos-stat-item">
                  <span className="datos-label">Retiro Discontinuo:</span>
                  <span className="datos-value">{formatearFecha(datosLaborales.RETIRO_DISCONTINUO)}</span>
                </div>
              )}
              {datosLaborales.TIEMPO_LABORADO && (
                <div className="datos-stat-item">
                  <span className="datos-label">Tiempo Laborado:</span>
                  <span className="datos-value">{datosLaborales.TIEMPO_LABORADO}</span>
                </div>
              )}
              {datosLaborales.fe_ingreso && (
                <div className="datos-stat-item">
                  <span className="datos-label">Fecha ingreso (Colpensiones):</span>
                  <span className="datos-value">{formatearTimestamp(datosLaborales.fe_ingreso)}</span>
                </div>
              )}
              {datosLaborales.fe_causa && (
                <div className="datos-stat-item">
                  <span className="datos-label">Fecha causación:</span>
                  <span className="datos-value">{formatearTimestamp(datosLaborales.fe_causa)}</span>
                </div>
              )}
              {datosLaborales.semanas && (
                <div className="datos-stat-item">
                  <span className="datos-label">Semanas cotizadas:</span>
                  <span className="datos-value">{datosLaborales.semanas}</span>
                </div>
              )}
              {(datosLaborales.res_nro || datosLaborales.res_ano) && (
                <div className="datos-stat-item">
                  <span className="datos-label">Resolución:</span>
                  <span className="datos-value">
                    {datosLaborales.res_nro ? `No. ${datosLaborales.res_nro}` : ''} 
                    {datosLaborales.res_ano ? ` de ${datosLaborales.res_ano}` : ''}
                  </span>
                </div>
              )}
            </div>
          </div>
        )}
        
        {/* Sección de datos pensionales */}
        {datosLaborales && (
          <div className="datos-pension-section">
            <h3>Información Pensional</h3>
            <div className="datos-pension-grid">
              {datosLaborales.SUELDO_PROMEDIO && (
                <div className="dato-pension-item">
                  <span className="dato-pension-label">Sueldo Promedio:</span>
                  <span className="dato-pension-value">{formatearValor(datosLaborales.SUELDO_PROMEDIO)}</span>
                </div>
              )}
              {datosLaborales.JUBILACION_ELECTRICARIBE && (
                <div className="dato-pension-item">
                  <span className="dato-pension-label">Jubilación Electricaribe:</span>
                  <span className="dato-pension-value">{formatearValor(datosLaborales.JUBILACION_ELECTRICARIBE)}</span>
                </div>
              )}
              {datosLaborales.PENSION_JUBILACION_1999 && (
                <div className="dato-pension-item">
                  <span className="dato-pension-label">Pensión Jubilación 1999:</span>
                  <span className="dato-pension-value">{formatearValor(datosLaborales.PENSION_JUBILACION_1999)}</span>
                </div>
              )}
              {datosLaborales.COMPARTICION && (
                <div className="dato-pension-item">
                  <span className="dato-pension-label">Compartición:</span>
                  <span className="dato-pension-value">{formatearValor(datosLaborales.COMPARTICION)}</span>
                </div>
              )}
              {datosLaborales.PENSION_JUBILACION_2006 && (
                <div className="dato-pension-item">
                  <span className="dato-pension-label">Pensión Jubilación 2006:</span>
                  <span className="dato-pension-value">{formatearValor(datosLaborales.PENSION_JUBILACION_2006)}</span>
                </div>
              )}
              {datosLaborales.PENSION_VEJEZ_2006 && (
                <div className="dato-pension-item">
                  <span className="dato-pension-label">Pensión Vejez 2006:</span>
                  <span className="dato-pension-value">{formatearValor(datosLaborales.PENSION_VEJEZ_2006)}</span>
                </div>
              )}
              {datosLaborales.MAYOR_VALOR_CARGO_EMPRESA && (
                <div className="dato-pension-item">
                  <span className="dato-pension-label">Mayor Valor a Cargo Empresa:</span>
                  <span className="dato-pension-value">{formatearValor(datosLaborales.MAYOR_VALOR_CARGO_EMPRESA)}</span>
                </div>
              )}
              {datosLaborales.mesada && (
                <div className="dato-pension-item">
                  <span className="dato-pension-label">Mesada inicial (Colpensiones):</span>
                  <span className="dato-pension-value">{formatoMoneda(datosLaborales.mesada)}</span>
                </div>
              )}
              {datosLaborales.EDAD_TERMINACION_CONTRATO && (
                <div className="dato-pension-item">
                  <span className="dato-pension-label">Edad al terminar contrato:</span>
                  <span className="dato-pension-value">{datosLaborales.EDAD_TERMINACION_CONTRATO}</span>
                </div>
              )}
            </div>
          </div>
        )}
        
        {/* Estadisticas globales de pagos */}
        {/* <div className="estadisticas-globales">
          <h3>Estadísticas Globales de Pagos</h3>
          <div className="global-stats">
            <div className="stat-item">
              <span className="stat-label">Total de pagos:</span>
              <span className="stat-value">{analisisData.global.totalPagos}</span>
            </div>
            <div className="stat-item">
              <span className="stat-label">Media de mesadas:</span>
              <span className="stat-value">{formatoMoneda(analisisData.global.mediaTodos)}</span>
            </div>
            <div className="stat-item">
              <span className="stat-label">Mediana de mesadas:</span>
              <span className="stat-value">{formatoMoneda(analisisData.global.medianaTodos)}</span>
            </div>
            <div className="stat-item">
              <span className="stat-label">Mesada más alta:</span>
              <span className="stat-value">{formatoMoneda(analisisData.global.maximoHistorico)}</span>
            </div>
            <div className="stat-item">
              <span className="stat-label">Mesada más baja:</span>
              <span className="stat-value">{formatoMoneda(analisisData.global.minimoHistorico)}</span>
            </div>
            
            {/* Nuevas estadísticas de mesadas adicionales *}
            {analisisData.global.cantidadMesadasAdicionales > 0 && (
              <div className="stat-item special-concept">
                <span className="stat-label">Mesadas adicionales:</span>
                <span className="stat-value">
                  {analisisData.global.cantidadMesadasAdicionales} pagos 
                  ({formatoMoneda(analisisData.global.totalMesadasAdicionales)})
                </span>
              </div>
            )}
            
            {/* Estadísticas de costas procesales *}
            {analisisData.global.totalCostasYSentencias > 0 && (
              <div className="stat-item special-concept">
                <span className="stat-label">Costas y sentencias:</span>
                <span className="stat-value">
                  {analisisData.global.costasYSentencias.length} pagos 
                  ({formatoMoneda(analisisData.global.totalCostasYSentencias)})
                </span>
              </div>
            )}
            
            {/* Estadísticas de retroactivos *}
            {analisisData.global.totalRetroactivos > 0 && (
              <div className="stat-item special-concept">
                <span className="stat-label">Retroactivos M14:</span>
                <span className="stat-value">
                  {analisisData.global.retroactivos.length} pagos 
                  ({formatoMoneda(analisisData.global.totalRetroactivos)})
                </span>
              </div>
            )}
            
            {/* Total de ingresos especiales *}
            {(analisisData.global.totalMesadasAdicionales > 0 || 
              analisisData.global.totalCostasYSentencias > 0 || 
              analisisData.global.totalRetroactivos > 0) && (
              <div className="stat-item total-special">
                <span className="stat-label">Total ingresos especiales:</span>
                <span className="stat-value">
                  {formatoMoneda(
                    analisisData.global.totalMesadasAdicionales + 
                    analisisData.global.totalCostasYSentencias + 
                    analisisData.global.totalRetroactivos
                  )}
                </span>
              </div>
            )}
          </div>
        </div> */}
        
        {/* Estadísticas Globales de Pagos */}
        <div className="estadisticas-globales">
          <h3>Estadísticas Globales de Pagos</h3>
          <div className="global-stats">
            <div className="stat-item">
              <span className="stat-label">Total de pagos:</span>
              <span className="stat-value">{analisisData.global.totalPagos}</span>
            </div>
            <div className="stat-item">
              <span className="stat-label">Media de mesadas:</span>
              <span className="stat-value">{formatoMoneda(analisisData.global.mediaTodos)}</span>
            </div>
            <div className="stat-item">
              <span className="stat-label">Mediana de mesadas:</span>
              <span className="stat-value">{formatoMoneda(analisisData.global.medianaTodos)}</span>
            </div>
            
            <div className="stat-item">
              <span className="stat-label">Mesada más alta:</span>
              <span className="stat-value">{formatoMoneda(analisisData.global.maximoHistorico)}</span>
            </div>
            <div className="stat-item">
              <span className="stat-label">Mesada más baja:</span>
              <span className="stat-value">{formatoMoneda(analisisData.global.minimoHistorico)}</span>
            </div>
            <div className="stat-item">
              <span className="stat-label">Mesadas adicionales:</span>
              <span className="stat-value">
                {analisisData.global.cantidadMesadasAdicionales > 0
                  ? `${analisisData.global.cantidadMesadasAdicionales} pagos (${formatoMoneda(analisisData.global.totalMesadasAdicionales)})`
                  : "0 pagos ($ 0)"}
              </span>
            </div>
            
            <div className="stat-item">
              <span className="stat-label">Costas Procesales (470):</span>
              <span className="stat-value">
                {analisisData.global.costasYSentencias.filter(c => c.concepto === "Costas Procesales").length > 0
                  ? `${analisisData.global.costasYSentencias.filter(c => c.concepto === "Costas Procesales").length} pagos (${formatoMoneda(analisisData.global.costasYSentencias.filter(c => c.concepto === "Costas Procesales").reduce((sum, c) => sum + c.valor, 0))})`
                  : "0 pagos ($ 0)"}
              </span>
            </div>
            <div className="stat-item">
              <span className="stat-label">Procesos y Sentencias (475):</span>
              <span className="stat-value">
                {analisisData.global.costasYSentencias.filter(c => c.concepto === "Procesos y Sentencias Judiciales").length > 0
                  ? `${analisisData.global.costasYSentencias.filter(c => c.concepto === "Procesos y Sentencias Judiciales").length} pagos (${formatoMoneda(analisisData.global.costasYSentencias.filter(c => c.concepto === "Procesos y Sentencias Judiciales").reduce((sum, c) => sum + c.valor, 0))})`
                  : "0 pagos ($ 0)"}
              </span>
            </div>
            <div className="stat-item">
              <span className="stat-label">Retroactivos M14 (785):</span>
              <span className="stat-value">
                {analisisData.global.totalRetroactivos > 0
                  ? `${analisisData.global.retroactivos.length} pagos (${formatoMoneda(analisisData.global.totalRetroactivos)})`
                  : "0 pagos ($ 0)"}
              </span>
            </div>
            
            <div className="stat-item total-special">
              <span className="stat-label">Total ingresos especiales:</span>
              <span className="stat-value">
                {formatoMoneda(
                  (analisisData.global.totalMesadasAdicionales || 0) + 
                  (analisisData.global.totalCostasYSentencias || 0) + 
                  (analisisData.global.totalRetroactivos || 0)
                )}
              </span>
            </div>
          </div>
        </div>
        
        {/* Tabla detallada de mesadas adicionales */}
        {/* {analisisData.global.cantidadMesadasAdicionales > 0 && (
          <div className="conceptos-especiales-seccion">
            <h4>Detalle de Mesadas Adicionales</h4>
            <table className="conceptos-table">
              <thead>
                <tr>
                  <th>Período</th>
                  <th>Mes</th>
                  <th>Valor</th>
                </tr>
              </thead>
              <tbody>
                {analisisData.global.mesadasAdicionales.sort((a, b) => b.anio - a.anio).map((m, i) => (
                  <tr key={i}>
                    <td>{m.periodo}</td>
                    <td>{m.mes}</td>
                    <td>{formatoMoneda(m.valor)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )} */}
        
        {/* Tabla detallada de costas y sentencias */}
        {analisisData.global.costasYSentencias.length > 0 && (
          <div className="conceptos-especiales-seccion">
            <h4>Detalle de Costas y Sentencias</h4>
            <table className="conceptos-table">
              <thead>
                <tr>
                  <th>Período</th>
                  <th>Concepto</th>
                  <th>Valor</th>
                </tr>
              </thead>
              <tbody>
                {analisisData.global.costasYSentencias.sort((a, b) => b.anio - a.anio).map((c, i) => (
                  <tr key={i}>
                    <td>{c.periodo}</td>
                    <td>{c.concepto}</td>
                    <td>{formatoMoneda(c.valor)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* Tabla detallada de retroactivos */}
        {analisisData.global.retroactivos.length > 0 && (
          <div className="conceptos-especiales-seccion">
            <h4>Detalle de Pagos Retroactivos</h4>
            <table className="conceptos-table">
              <thead>
                <tr>
                  <th>Período</th>
                  <th>Concepto</th>
                  <th>Valor</th>
                </tr>
              </thead>
              <tbody>
                {analisisData.global.retroactivos.sort((a, b) => b.anio - a.anio).map((r, i) => (
                  <tr key={i}>
                    <td>{r.periodo}</td>
                    <td>{r.concepto}</td>
                    <td>{formatoMoneda(r.valor)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        
        {/* Análisis por año */}
        {analisisData.global.anios.map(anio => (
          <div key={anio} className="estadisticas-anuales">
            <h3>Año {anio}</h3>
            <div className="annual-stats">
              <div className="stat-item">
                <span className="stat-label">Cantidad de pagos:</span>
                <span className="stat-value">{analisisData.porAnio[anio].cantidadPagos}</span>
              </div>
              <div className="stat-item">
                <span className="stat-label">Media anual:</span>
                <span className="stat-value">{formatoMoneda(analisisData.porAnio[anio].media)}</span>
              </div>
              <div className="stat-item">
                <span className="stat-label">Mediana anual:</span>
                <span className="stat-value">{formatoMoneda(analisisData.porAnio[anio].mediana)}</span>
              </div>
              <div className="stat-item">
                <span className="stat-label">Mesada más alta:</span>
                <span className="stat-value">{formatoMoneda(analisisData.porAnio[anio].maximo)}</span>
              </div>
              <div className="stat-item">
                <span className="stat-label">Mesada más baja:</span>
                <span className="stat-value">{formatoMoneda(analisisData.porAnio[anio].minimo)}</span>
              </div>
              
              {/* Nuevos items para mesadas adicionales y conceptos especiales */}
              {analisisData.porAnio[anio].cantidadMesadasAdicionales > 0 && (
                <div className="stat-item special-concept">
                  <span className="stat-label">Mesadas adicionales:</span>
                  <span className="stat-value">
                    {analisisData.porAnio[anio].cantidadMesadasAdicionales} pagos 
                    ({formatoMoneda(analisisData.porAnio[anio].totalMesadasAdicionales)})
                  </span>
                </div>
              )}
              
              {analisisData.porAnio[anio].totalCostasYSentencias > 0 && (
                <div className="stat-item special-concept">
                  <span className="stat-label">Costas y sentencias:</span>
                  <span className="stat-value">
                    {formatoMoneda(analisisData.porAnio[anio].totalCostasYSentencias)}
                  </span>
                </div>
              )}
              
              {analisisData.porAnio[anio].totalRetroactivos > 0 && (
                <div className="stat-item special-concept">
                  <span className="stat-label">Retroactivos M14:</span>
                  <span className="stat-value">
                    {formatoMoneda(analisisData.porAnio[anio].totalRetroactivos)}
                  </span>
                </div>
              )}
              
              {analisisData.porAnio[anio].incrementoTotal !== 0 && (
                <div className="stat-item">
                  <span className="stat-label">Incremento total en el año:</span>
                  <span className={`stat-value ${analisisData.porAnio[anio].incrementoTotal > 0 ? 'positivo' : 'negativo'}`}>
                    {formatoMoneda(analisisData.porAnio[anio].incrementoTotal)} 
                    ({analisisData.porAnio[anio].porcentajeIncrementoTotal}%)
                  </span>
                </div>
              )}
            </div>
            
            {/* Variaciones de mesadas (mantener esta sección) */}
            {analisisData.porAnio[anio].variaciones.length > 0 && (
              <div className="variaciones-container">
                <h4>Variaciones en mesadas</h4>
                <table className="variaciones-table">
                  <thead>
                    <tr>
                      <th>Desde</th>
                      <th>Hasta</th>
                      <th>Diferencia</th>
                      <th>Porcentaje</th>
                    </tr>
                  </thead>
                  <tbody>
                    {analisisData.porAnio[anio].variaciones.map((v, i) => (
                      <tr key={i}>
                        <td>{v.desde}</td>
                        <td>{v.hasta}</td>
                        <td className={v.diferencia >= 0 ? 'positivo' : 'negativo'}>
                          {formatoMoneda(v.diferencia)}
                        </td>
                        <td className={v.porcentaje >= 0 ? 'positivo' : 'negativo'}>
                          {v.porcentaje}%
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            
            {/* Detalle de pagos */}
            <div className="pagos-detalle">
              <h4>Detalle de pagos</h4>
              <table className="pagos-table">
                <thead>
                  <tr>
                    <th>Periodo</th>
                    <th>Mesada</th>
                    <th>Valor Neto</th>
                    <th>Conceptos especiales</th>
                  </tr>
                </thead>
                <tbody>
                  {analisisData.porAnio[anio].pagos.map((p, i) => (
                    <tr key={i} className={p.tieneAdicional ? 'fila-adicional' : ''}>
                      <td>{p.periodo}</td>
                      <td>{formatoMoneda(p.mesada)}</td>
                      <td>{formatoMoneda(p.valorNeto)}</td>
                      <td>
                        {p.tieneAdicional && <span className="tag adicional">Mesada adicional</span>}
                        {p.conceptosEspeciales?.costas > 0 && <span className="tag costas">Costas</span>}
                        {p.conceptosEspeciales?.retroM14 > 0 && <span className="tag retro">Retroactivo M14</span>}
                        {p.conceptosEspeciales?.sentencias > 0 && <span className="tag sentencias">Sentencias</span>}
                        {!p.tieneAdicional && 
                         !p.conceptosEspeciales?.costas > 0 && 
                         !p.conceptosEspeciales?.retroM14 > 0 && 
                         !p.conceptosEspeciales?.sentencias > 0 && 
                         <span className="tag regular">Regular</span>}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            
            {/* Detalle de conceptos especiales por año */}
            {(analisisData.porAnio[anio].cantidadMesadasAdicionales > 0 ||
              analisisData.porAnio[anio].costasYSentencias?.length > 0 ||
              analisisData.porAnio[anio].retroactivos?.length > 0) && (
              <div className="conceptos-especiales-anual">
                <h4>Conceptos especiales en {anio}</h4>
                
                {/* Detalle de mesadas adicionales */}
                {analisisData.porAnio[anio].mesadasAdicionales?.length > 0 && (
                  <div className="detalle-concepto">
                    <h5>Mesadas adicionales</h5>
                    <table className="conceptos-table">
                      <thead>
                        <tr>
                          <th>Periodo</th>
                          <th>Mes</th>
                          <th>Valor</th>
                        </tr>
                      </thead>
                      <tbody>
                        {analisisData.porAnio[anio].mesadasAdicionales.map((m, i) => (
                          <tr key={i}>
                            <td>{m.periodo}</td>
                            <td>{m.mes}</td>
                            <td>{formatoMoneda(m.valor)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
                
                {/* Detalle de costas y sentencias */}
                {analisisData.porAnio[anio].costasYSentencias?.length > 0 && (
                  <div className="detalle-concepto">
                    <h5>Costas y sentencias judiciales</h5>
                    <table className="conceptos-table">
                      <thead>
                        <tr>
                          <th>Periodo</th>
                          <th>Concepto</th>
                          <th>Valor</th>
                        </tr>
                      </thead>
                      <tbody>
                        {analisisData.porAnio[anio].costasYSentencias.map((c, i) => (
                          <tr key={i}>
                            <td>{c.periodo}</td>
                            <td>{c.concepto}</td>
                            <td>{formatoMoneda(c.valor)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
                
                {/* Detalle de retroactivos */}
                {analisisData.porAnio[anio].retroactivos?.length > 0 && (
                  <div className="detalle-concepto">
                    <h5>Pagos retroactivos</h5>
                    <table className="conceptos-table">
                      <thead>
                        <tr>
                          <th>Periodo</th>
                          <th>Concepto</th>
                          <th>Valor</th>
                        </tr>
                      </thead>
                      <tbody>
                        {analisisData.porAnio[anio].retroactivos.map((r, i) => (
                          <tr key={i}>
                            <td>{r.periodo}</td>
                            <td>{r.concepto}</td>
                            <td>{formatoMoneda(r.valor)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <button className="modal-close-btn" onClick={onClose}>×</button>
        <div className="modal-body">
          {contenidoModal}
        </div>
      </div>
    </div>
  );
};

export default AnalisisPagos;